/**
 * 金額の取り扱い。
 *
 * 金額はすべて「最小通貨単位の整数」で保持する (JPY なら 1 = 1円、USD なら 1 = 1セント)。
 * 浮動小数点で金額を扱うと 1 円単位のズレが発生し、割り勘アプリでは致命的なため、
 * ドメイン層では常に整数で計算し、表示のときだけ通貨表記へ変換する。
 */
export const CURRENCIES = {
    JPY: { code: "JPY", symbol: "¥", minorUnitDigits: 0, label: "日本円" },
    USD: { code: "USD", symbol: "$", minorUnitDigits: 2, label: "米ドル" },
    EUR: { code: "EUR", symbol: "€", minorUnitDigits: 2, label: "ユーロ" },
    KRW: { code: "KRW", symbol: "₩", minorUnitDigits: 0, label: "韓国ウォン" },
    TWD: { code: "TWD", symbol: "NT$", minorUnitDigits: 0, label: "台湾ドル" },
};
export const CURRENCY_CODES = Object.keys(CURRENCIES);
export function getCurrency(code) {
    return CURRENCIES[code];
}
/** 最小通貨単位の整数として妥当か (安全な整数かつ非負) */
export function isValidMinorAmount(value) {
    return Number.isSafeInteger(value) && value >= 0;
}
/**
 * 表示用の文字列へ変換する。
 * 例: toDisplayAmount(1234, "JPY") === "1,234"
 *     toDisplayAmount(1234, "USD") === "12.34"
 */
export function toDisplayAmount(minor, code) {
    const { minorUnitDigits } = getCurrency(code);
    const sign = minor < 0 ? "-" : "";
    const abs = Math.abs(minor);
    if (minorUnitDigits === 0)
        return sign + abs.toLocaleString("ja-JP");
    const divisor = 10 ** minorUnitDigits;
    const major = Math.floor(abs / divisor);
    const rest = String(abs % divisor).padStart(minorUnitDigits, "0");
    return `${sign}${major.toLocaleString("ja-JP")}.${rest}`;
}
/** 記号付きの表示 (例: "¥1,234") */
export function formatMoney(minor, code) {
    const { symbol } = getCurrency(code);
    const body = toDisplayAmount(minor, code);
    return body.startsWith("-") ? `-${symbol}${body.slice(1)}` : `${symbol}${body}`;
}
/**
 * ユーザー入力 (例: "1,200" / "1200円" / "12.34") を最小通貨単位へ変換する。
 * 解釈できない場合は null を返す。
 */
export function parseAmountInput(input, code) {
    const normalized = input
        .replace(/[０-９．，]/g, (c) => String.fromCharCode(c.charCodeAt(0) - 0xfee0))
        .replace(/[,\s円$€₩]/g, "")
        .trim();
    if (normalized === "" || !/^-?\d*(\.\d+)?$/.test(normalized))
        return null;
    const { minorUnitDigits } = getCurrency(code);
    const value = Number(normalized);
    if (!Number.isFinite(value))
        return null;
    const minor = Math.round(value * 10 ** minorUnitDigits);
    return Number.isSafeInteger(minor) ? minor : null;
}
//# sourceMappingURL=money.js.map